import {
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Inject,
  Page,
  Resize,
  PageSettingsModel,
  Toolbar,
  SelectionSettingsModel,
  ColumnChooser,
  ExcelExport,
  Group,
} from '@syncfusion/ej2-react-grids';
import {
  AnimationSettingsModel,
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import moment from 'moment';
import React, { Component } from 'react';
import  { all_information, loadingShow } from '../../../App';
import { ThemeContext } from '../../../context/theme.context';
import {
  AddShiftWorkbenchSubStuff,
  DeleteShiftWorkbenchSubStuff,
  EditShiftWorkbenchSubStuff,
  getShiftWorkbenchSubStuff,
} from '../../../services/ShiftWorkbench/ShiftWorkbenchSubStuff';
import {getShiftWorkbenchTemplate} from '../../../services/ShiftWorkbench/ShitWorkbenchTemplateService';
import Message from '../../../utils/Message/Message';
import './style.css';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { getShiftWorkbenchSettings } from '../../../services/ShiftWorkbench/ShitWorkbenchSettingsServices';
import { getTeamAssigments } from '../../../services/tradeperson/team';
import { getAssignments } from '../../../services/assignments/assignmentService';
interface IProps {
  workbench_data: any;
}
interface IState {
  data: Array<string>;
  AssetData: Array<any>;
  TeamAssignmentData: Array<any>;
  hideDialogTemplate: boolean;
  hideDialogDelete: boolean;
  TemplateData: Array<any>;
  renderFunction: boolean;
  hideDialogIsAdded: boolean;
}
class EquipmentSummary extends Component<IProps, IState> {
  public toolbarOptions = [
    'Add',
    'Edit',
    {
      text: 'Delete',
      tooltipText: 'Delete',
      prefixIcon: 'e-delete',
      id: 'delete',
    },
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    {
      text: 'Apply Default Template',
      tooltipText: 'Apply Default Template',
      prefixIcon: 'e-save',
      id: 'apply-template',
    },
    {
      text: 'Template',
      tooltipText: 'Template',
      prefixIcon: 'e-add',
      id: 'add-template',
    },
    'ColumnChooser',
    'ExcelExport',
    'Search',
  ];
  private fieldOperator: object = {
    text: 'alias_name',
    value: 'assignment_id',
  };
  private fieldAssetType: object = {
    text: 'asset_code',
    value: 'id',
  };
  private fieldTemplate: object = {
    text: 'name',
    value: 'id',
  };
  private buttonsForDelete: ButtonPropsModel[];
  private buttonsIsAddedEquipment: ButtonPropsModel[];
  public validationRule: Object = { required: true };
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  private created_date = new Date();
  private workbench_id = -1;
  private team_id = -1;
  private TemplateData: any = [];
  private is_override: any = false;
  private numericParams = { params: { decimals: 2 } };
  private dropDownListObjectOperator: any;
  private dropDownListObjectAssetType: any;
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private animationSettings: AnimationSettingsModel;
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 20,
    pageCount: 10,
  };
  public editOptions: EditSettingsModel = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: false,
    newRowPosition: 'Top',
  };
  private settings: SelectionSettingsModel = {
    checkboxMode: 'ResetOnRowClick',
    checkboxOnly: false,
  };
  private gridWPEquipmentSObj: any;
  private unit: string = 'eqsum';
  constructor(props: IProps) {
    super(props);
    this.animationSettings = { effect: 'Zoom', duration: 400, delay: 0 };
    this.state = {
      data: [],
      AssetData: [],
      TeamAssignmentData: [],
      TemplateData: [],
      hideDialogTemplate: false,
      hideDialogDelete: false,
      renderFunction: false,
      hideDialogIsAdded: false,
    };
    this.buttonsForDelete = [
      {
        click: () => {
          this.savePointDelete();
        },
        buttonModel: {
          content: 'OK',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogDelete: false });
        },
        buttonModel: {
          content: 'Cancel',
          isPrimary: false,
        },
      },
    ];
    this.buttonsIsAddedEquipment = [
      {
        click: () => {
          this.is_override = false;
          this.SavePointTemplateEquipment();
        },
        buttonModel: {
          content: 'Append',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.is_override = true;
          this.SavePointTemplateEquipment();
        },
        buttonModel: {
          content: 'Override',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogIsAdded: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
  }
  async componentDidMount() {
    this.workbench_id = parseInt(this.props.workbench_data.id);
    this.created_date = new Date(this.props.workbench_data.date);
    this.team_id = parseInt(this.props.workbench_data.team_id);
    this.getWorkbenchEquipmentSummary(`${this.unit}$${this.workbench_id}`);
    this.getAllAssignment();
    // else this.getTeamAssignment(this.team_id);
    await this.getAssetType();
    await this.getWorkbenchTemplateemplate('Equipment Summary');
    loadingShow(false);
  }
  async SavePointTemplateEquipment() {
    let data = this.TemplateData;
    let obj = data.details.map((item: any) => {
      return {
        asset_type_id: item.asset_id,
        operator_: item.assignment_code,
        assignment_id: item.assignment_id,
        asset_number: item.asset_number,
        app: 'app',
        organization_id: all_information.company_id?.toString(),
        workbench_id: this.workbench_id,
        date: this.created_date,
        template_id: data.id,
        user_id: all_information.user_id,
        is_override: this.is_override,
        unit: this.unit,
      };
    });
    loadingShow(true);
    await AddShiftWorkbenchSubStuff(obj)
      .then((res) => {
        Message.success('Success');
        this.getWorkbenchEquipmentSummary(`${this.unit}$${this.workbench_id}`);
        this.setState({ hideDialogIsAdded: false });
        loadingShow(false);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  actionBeginProductionEquipmentSummary(args: any) {
    if (args.action === 'add') {
      this.savePointAddEquipmentSummary(args.data);
    } else if (args.action === 'edit') {
      this.savePointEditEquipmentSummary(args.data);
    }
  }
  getTeamAssignment(teamID: number) {
    getTeamAssigments(teamID).then((res) => {
      this.setState({ TeamAssignmentData: res.data });
    });
  }
  getAllAssignment() {
    getAssignments().then((res) => {
      this.setState({ TeamAssignmentData: res.data });
    });
  }
  async getAssetType() {
    await getShiftWorkbenchSettings('assettype').then((res) => {
      let model = res.data.map((items: any) => {
        return {
          ...items,
        };
      });
      this.setState({ AssetData: model });
    });
  }
  getWorkbenchEquipmentSummary(query: string) {
    getShiftWorkbenchSubStuff(query).then((res) => {
      this.setState({ data: res.data });
    });
  }
  async savePointAddEquipmentSummary(obje: any) {
    let operator = this.dropDownListObjectOperator.text;
    let assignment_id = this.dropDownListObjectOperator.value;
    let asset = this.dropDownListObjectAssetType.value;
    var date = this.created_date;
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      workbench_id: this.workbench_id,
      asset_type_id: asset,
      description: obje.description,
      prestart_no: obje.prestart_no,
      asset_number: obje.asset_number,
      shot_id: obje.shot_id,
      fleet_no: '',
      operator_: operator,
      assignment_id: assignment_id,
      start_hrs: obje.start_hrs,
      end_hrs: obje.end_hrs,
      shift_engine_hours: obje.end_hrs - obje.start_hrs,
      equipment_faults: obje.equipment_faults,
      breakdown: obje.breakdown,
      service: obje.service,
      eos: obje.eos,
      standby: 12 - (obje.end_hrs - obje.start_hrs),
      blasting: obje.blasting,
      batters: obje.batters,
      day_works: obje.day_works,
      top_loading: obje.top_loading,
      other: obje.other,
      tramming: obje.tramming,
      weather: obje.weather,
      date: date,
      user_id: all_information.user_id,
      template_id: -1,
      unit: this.unit,
    });
    AddShiftWorkbenchSubStuff(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchEquipmentSummary(`${this.unit}$${this.workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  async savePointEditEquipmentSummary(obje: any) {
    let operator = this.dropDownListObjectOperator.text;
    let assignment_id = this.dropDownListObjectOperator.value;
    let asset = this.dropDownListObjectAssetType.value;
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      workbench_id: this.workbench_id,
      asset_type_id: asset,
      description: obje.description,
      prestart_no: obje.prestart_no,
      asset_number: obje.asset_number,
      shot_id: obje.shot_id,
      fleet_no: '',
      operator_: operator,
      assignment_id,
      start_hrs: obje.start_hrs,
      end_hrs: obje.end_hrs,
      shift_engine_hours: obje.end_hrs - obje.start_hrs,
      equipment_faults: obje.equipment_faults,
      breakdown: obje.breakdown,
      service: obje.service,
      eos: obje.eos,
      standby: 12 - (obje.end_hrs - obje.start_hrs),
      blasting: obje.blasting,
      batters: obje.batters,
      day_works: obje.day_works,
      top_loading: obje.top_loading,
      other: obje.other,
      tramming: obje.tramming,
      weather: obje.weather,
      date: obje.date,
      user_id: all_information.user_id,
      id: obje.id,
      template_id: obje.template_id,
      unit: this.unit,
    });

    EditShiftWorkbenchSubStuff(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchEquipmentSummary(`${this.unit}$${this.workbench_id}`);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  async savePointDelete() {
    let data = (this.gridWPEquipmentSObj as GridComponent).getSelectedRecords();
    loadingShow(true);
    DeleteShiftWorkbenchSubStuff(data)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchEquipmentSummary(`${this.unit}$${this.workbench_id}`);
        this.setState({ hideDialogDelete: false });
        loadingShow(false);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  private async toolbarClick(args: any) {
    if (args.item.text === 'Add') {
      if (this.workbench_id === -1) {
        Message.error('Please create a workbench first!');
        this.gridWPEquipmentSObj.refresh();
      }
    }
    if (
      this.gridWPEquipmentSObj &&
      args.item.id === 'gridWorkbenchProductionEquipmentSummary_excelexport'
    ) {
      this.gridWPEquipmentSObj.excelExport();
    }
    if (args.item.id === 'delete') {
      if (this.workbench_id === -1) {
        Message.error('Please create a workbench first!');
        this.gridWPEquipmentSObj.refresh();
      }
      if (
        (this.gridWPEquipmentSObj as GridComponent).getSelectedRecords()
          .length > 0
      ) {
        this.setState({ hideDialogDelete: true });
      } else {
        Message.error('Please select a record!');
      }
    }
    if (args.item.id === 'refresh') {
      this.getWorkbenchEquipmentSummary(`${this.unit}$${this.workbench_id}`);
    }
    if (args.item.id === 'add-template') {
      if (this.workbench_id === -1) {
        Message.error('Please create a workbench first!');
        this.gridWPEquipmentSObj.refresh();
      } else {
        this.context.setChangeCurrentTabWorkbenchBottom(
          true,
          this.workbench_id
        );
        this.context.setDataChangeWorkbenchBottomData(
          true,
          this.created_date +
            ',' +
            this.workbench_id +
            ',' +
            'Equipment Summary'
        );
      }
    }
    if (args.item.id === 'apply-template') {
      if (this.workbench_id === -1) {
        Message.error('Please create a workbench first!');
        return false;
      }

      let findTemplate = this.state.TemplateData.find(
        (x: any) => x.isDefault === true
      );

      if (findTemplate !== undefined) {
        this.TemplateData = findTemplate;
        await this.getWorkbenchEquipmentSummary(
          `${this.unit}$${this.workbench_id}`
        );
        let findData = this.state.data.find(
          (x: any) => x.template_id === findTemplate.id
        );
        if (findData !== undefined) this.setState({ hideDialogIsAdded: true });
        else this.SavePointTemplateEquipment();
      } else {
        Message.error('Default template not found!');
      }
    }
  }
  getWorkbenchTemplateemplate(whereModule: string) {
    getShiftWorkbenchTemplate().then((result) => {
      let filterData: any = result.data;
      if (whereModule !== '') {
        filterData = result.data.filter((x: any) => x.tab_name === whereModule);
      }
      this.setState({ TemplateData: filterData });
    });
  }
  private OperatorTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        placeholder='Operator'
        text={args.operator_}
        value={args.assignment_id}
        dataSource={this.state.TeamAssignmentData}
        ref={(scope) => (this.dropDownListObjectOperator = scope)}
        onChange={(e: any) => {
          //(e);
        }}
        fields={this.fieldOperator}
      />
    );
  }
  private AssetTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        placeholder='Asset Type'
        text={args.asset_code}
        value={args.asset_type_id}
        dataSource={this.state.AssetData}
        ref={(scope) => (this.dropDownListObjectAssetType = scope)}
        fields={this.fieldAssetType}
      />
    );
  }
  render() {
    return (
      <div className='workbench-production-EquipmentSummary'>
        <GridComponent
          id='gridWorkbenchProductionEquipmentSummary'
          dataSource={this.state.data}
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          ref={(g) => (this.gridWPEquipmentSObj = g)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          toolbarClick={this.toolbarClick.bind(this)}
          showColumnMenu={true}
          allowResizing={true}
          selectionSettings={this.settings}
          allowExcelExport
          enablePersistence
          showColumnChooser
          allowGrouping={true}
          style={{ display: 'inline-block' }}
          gridLines='Both'
          width={window.innerWidth - 115}
          height={'calc(-200px + 60vh)'}
          delayUpdate={true}
          actionBegin={this.actionBeginProductionEquipmentSummary.bind(this)}
        >
          <ColumnsDirective>
            <ColumnDirective
              textAlign='Center'
              type='checkbox'
              allowEditing={false}
            />
            <ColumnDirective
              field='prestart_no'
              headerText='Pre-Start No'
              textAlign='Left'
            />
            <ColumnDirective
              field='asset_type'
              headerText='Asset Type'
              textAlign='Left'
              editType='dropdownedit'
              width={200}
              editTemplate={this.AssetTemplateEditing.bind(this)}
            />
            <ColumnDirective
              field='asset_number'
              headerText='Asset Number'
              textAlign='Left'
              width={100}
            />
            <ColumnDirective
              field='operator_'
              headerText='Operator'
              editType='dropdownedit'
              width={200}
              editTemplate={this.OperatorTemplateEditing.bind(this)}
            />
            <ColumnDirective
              field='start_hrs'
              headerText='Start Hours'
              editType='numericedit'
              width={150}
              edit={this.numericParams}
            />
            <ColumnDirective
              field='end_hrs'
              headerText='End Hours'
              editType='numericedit'
              width={150}
              edit={this.numericParams}
            />
            <ColumnDirective
              field='shift_engine_hours'
              headerText='Shift Engine Hours'
              allowEditing={false}
            />
            <ColumnDirective field='breakdown' headerText='Breakdown' />
            <ColumnDirective field='service' headerText='Service' />
            <ColumnDirective field='weather' headerText='Weather' />
            <ColumnDirective field='blasting' headerText='Blasting' />
            <ColumnDirective field='eos' headerText='EOS' />
            <ColumnDirective field='batters' headerText='Batters' />
            <ColumnDirective field='tramming' headerText='Tramming' />
            <ColumnDirective field='day_works' headerText='Day Works' />
            <ColumnDirective field='top_loading' headerText='Top Loading' />
            <ColumnDirective field='other' headerText='Other' />
            <ColumnDirective
              field='standby'
              headerText='Standby'
              allowEditing={false}
            />

            <ColumnDirective
              field='description'
              headerText='Comments / Shift Notes / Dayworks Description'
            />
            <ColumnDirective
              field='equipment_faults'
              headerText='Equipment Faults/Down Time'
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              Page,
              ColumnChooser,
              ExcelExport,
              ColumnMenu,
              Resize,
              Group
            ]}
          />
        </GridComponent>
        <div className='control-pane-dialog'>
          <div
            id='targetElement'
            className='col-lg-12 defaultDialog dialog-target'
          >
            {this.state.hideDialogDelete ? (
              <DialogComponent
                isModal={true}
                id='modalSummaryDelete'
                animationSettings={{
                  delay: 1,
                  duration: 500,
                  effect: 'FadeZoom',
                }}
                showCloseIcon={true}
                visible={this.state.hideDialogDelete}
                header='Confirmation'
                width={200}
                height={'auto'}
                buttons={this.buttonsForDelete}
                open={() => {
                  this.setState({ hideDialogDelete: true });
                }}
                close={() => {
                  this.setState({ hideDialogDelete: false });
                }}
              >
                <div className='container'>
                  <div className='row'>Are you sure?</div>
                </div>
              </DialogComponent>
            ) : null}
            {this.state.hideDialogIsAdded ? (
              <DialogComponent
                isModal={true}
                id='defaultDialogIsAddedEquipment'
                showCloseIcon={true}
                beforeClose={() => {
                  this.setState({ hideDialogIsAdded: false });
                }}
                animationSettings={this.animationSettings}
                visible={this.state.hideDialogIsAdded}
                header='Confirmation'
                width={500}
                height={'auto'}
                buttons={this.buttonsIsAddedEquipment}
                open={() => {
                  this.setState({ hideDialogIsAdded: true });
                }}
                close={() => {
                  this.setState({ hideDialogIsAdded: false });
                }}
              >
                <div className='container'>
                  <div className='row'>
                    <span>
                      This template has already been added. Would you like to
                      add it again?
                    </span>
                  </div>
                </div>
              </DialogComponent>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
export default EquipmentSummary;
